"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaterMain = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var WaterMain = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black : _b;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("defs", null,
            React.createElement("path", { d: "M18,6 L20,8 L20,10.999 L15.999,10.999 L15.999,8 L18,6 Z M11.999,6 L13.998,8 L13.998,10.999 L9.999,10.999 L9.999,8 L11.999,6 Z M5.998,6 L7.998,8 L7.998,10.999 L3.999,10.999 L3.999,8 L5.998,6 Z M16.999,12 L19,12 L19,14.001 L21,14.001 L21,18.001 L2.999,18.001 L2.999,14.001 L4.999,14.001 L4.999,12 L6.999,12 L6.999,14.001 L11,14.001 L11,12 L13,12 L13,14.001 L16.999,14.001 L16.999,12 Z", id: "WATER-MAIN-SVG-ICON-PATH-1" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "WATER-MAIN-SVG-ICON-MASK-2", fill: "white" },
                React.createElement("use", { xlinkHref: "#WATER-MAIN-SVG-ICON-PATH-1" })),
            React.createElement("g", null),
            React.createElement("g", { mask: "url(#WATER-MAIN-SVG-ICON-MASK-2)", fill: color },
                React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })))));
};
exports.WaterMain = WaterMain;
//# sourceMappingURL=WaterMain.js.map